import Phaser from "phaser";
import { Constants } from "@core/Utils/Constants";
import { QuestionDialog } from "./QuestionDialog";
import { setTextFontScaledToBox } from "@core/Utils/HelperFunction";
import { Language } from "../Language";

//?basic true/false user input
export class ConfirmationQuestion extends QuestionDialog {

    private dialogSolidBackground: RexPlugins.GameObjects.NinePatch;
    private confirmationButton: Phaser.GameObjects.Image;
    private cancelButton: Phaser.GameObjects.Image;
    private question: Phaser.GameObjects.Text;

    constructor(public scene: Phaser.Scene, callback: Function, width: number, height: number, portraitMode: Boolean, private questionMessage, questionStyle) {
        super(scene, callback, width, height, portraitMode);

        this.dialogSolidBackground = new RexPlugins.GameObjects.NinePatch(scene, width / 2, height / 2, width / 4, height / 4, Constants.SPRITESHEET_MENU, "MenuBackground.png", [16, undefined, 16], [16, undefined, 16], { edge: 'scale', internal: 'scale' }).setOrigin(0.5);
        this.add(this.dialogSolidBackground);

        this.question = new Phaser.GameObjects.Text(scene, 0, 0, Language.Get(questionMessage), questionStyle).setOrigin(0.5);
        this.add(this.question);

        this.confirmationButton = new Phaser.GameObjects.Image(scene, 0, 0, Constants.SPRITESHEET_MENU, "confirmButton.png").setOrigin(0.5);
        this.confirmationButton.setInteractive();
        this.confirmationButton.on('pointerup', (p, x, y, e) => {
            this.callback(true);
        }, this);
        this.add(this.confirmationButton);

        this.cancelButton = new Phaser.GameObjects.Image(scene, 0, 0, Constants.SPRITESHEET_MENU, "cancelButton.png").setOrigin(0.5);
        this.cancelButton.setInteractive();
        this.cancelButton.on('pointerup', (p, x, y, e) => {
            this.callback(false);
        }, this);
        this.add(this.cancelButton);
    }

    public override OnResize(width: number, height: number, portraitMode?: Boolean): void {
        super.OnResize(width, height, portraitMode);

        if (!this.dialogSolidBackground)
            return;

        this.dialogSolidBackground.setSize(width / 3, height / 3);
        this.dialogSolidBackground.setPosition(width / 2, height / 2);

        this.question.text = Language.Get(this.questionMessage);
        setTextFontScaledToBox(this.question, this.dialogSolidBackground.displayWidth * 1.3, this.dialogSolidBackground.displayHeight * 0.7);
        this.question.setPosition(this.dialogSolidBackground.x, this.dialogSolidBackground.y - this.question.displayHeight * 0.8);

        this.confirmationButton.setDisplaySize(this.dialogSolidBackground.displayWidth / 4, this.dialogSolidBackground.displayHeight * 0.3);
        this.confirmationButton.setScale(Math.min(this.confirmationButton.scaleX, this.confirmationButton.scaleY));

        this.confirmationButton.setPosition(this.dialogSolidBackground.x + this.dialogSolidBackground.displayWidth / 2 - this.confirmationButton.displayWidth * 1.1, this.dialogSolidBackground.y + this.dialogSolidBackground.displayHeight / 2 - this.confirmationButton.displayHeight * 1.1);

        this.cancelButton.scale = this.confirmationButton.scale;
        this.cancelButton.setPosition(this.dialogSolidBackground.x - this.dialogSolidBackground.displayWidth / 2 + this.confirmationButton.displayWidth * 1.1, this.confirmationButton.y);
    }
}